<template>
  <div>
    <header-navigation not-fixed>
      <template #left-actions>
        <div class="d-flex align-items-center">
          <b-button v-if="!blockPreviousStep"
                    class="hitbox-min-size pl-0"
                    variant="link"
                    @click="$router.go(-1)"
          >
            <sdui-icon class="icon-chevron-back-o text-primary icon-28 ml-1" />
            <span class="sr-only">{{ $t('global.back') }}</span>
          </b-button>
          <b-badge v-if="userRole"
                   variant="dark"
                   class="rounded ml-1 registration-badge"
          >
            {{ userRole }}
          </b-badge>
        </div>
      </template>

      <template #right-actions v-if="$hasSlotContent($slots.button)">
        <div class="text-right mr-2 hitbox-min-width">
          <slot name="button" />
        </div>
      </template>
    </header-navigation>
  </div>
</template>

<script>
import registrationMixin from 'src/mixins/authentification/registrationMixin.js'
import HeaderNavigation from 'src/components/miscellaneous/ui/common/HeaderNavigation.vue'

export default {
  name: 'SduiRegistrationHeader',
  components: { HeaderNavigation },
  mixins: [registrationMixin],
  props: { user: { type: Object, default: () => ({}) } },

  computed: {
    blockPreviousStep() {
      return this.steps[this.currentStepIndex - 1] === 'user-editing-block'
    },

    userRole() {
      // user is empty on child registration
      return this.user?.primary_role?.translated_description
    },
  },
}
</script>

<style scoped lang="scss">
.registration-badge {
  white-space: normal;
  hyphens: auto;
}
</style>
